const prodFlags = {
    airDelivery: true,
    ticketing: true,
}

const testingFlags = {
    airDelivery: true,
    ticketing: true,
}

export function featureIsActive(name) {
    if (process.env.NODE_ENV !== 'production') return true;

    if (prodFlags[name] !== undefined) return prodFlags[name];
    return true
}
